import { render, staticRenderFns } from "./Certifications.vue?vue&type=template&id=6a596894"
import script from "./Certifications.vue?vue&type=script&lang=ts"
export * from "./Certifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports